"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Neil = void 0;
const CardName_1 = require("../../CardName");
const CardRenderer_1 = require("../render/CardRenderer");
const Card_1 = require("../Card");
const CardType_1 = require("../CardType");
const Tags_1 = require("../Tags");
const Resources_1 = require("../../Resources");
const Size_1 = require("../render/Size");
class Neil extends Card_1.Card {
    constructor() {
        super({
            name: CardName_1.CardName.NEIL,
            cardType: CardType_1.CardType.LEADER,
            tags: [Tags_1.Tags.MOON],
            metadata: {
                cardNumber: 'L34',
                renderData: CardRenderer_1.CardRenderer.builder((b) => {
                    b.moon(1).played.any.colon().megacredits(1);
                    b.br.br;
                    b.opgArrow().production((pb) => pb.megacredits(1000)).nbsp(Size_1.Size.SMALL).asterix();
                }),
                description: 'Gain 1 M€ when any player plays a Moon tag, including this. Once per game, increase your M€ production by the value of the LOWEST Moon rate.',
            },
        });
        this.isDisabled = false;
    }
    play(player) {
        player.megaCredits += 1;
        return undefined;
    }
    onCardPlayed(player, card) {
        const moonTagCount = card.tags.filter((tag) => tag === Tags_1.Tags.MOON).length;
        if (moonTagCount > 0) {
            player.game.getCardPlayer(this.name).addResource(Resources_1.Resources.MEGACREDITS, moonTagCount, { log: true });
        }
    }
    canAct() {
        return this.isDisabled === false;
    }
    action(player) {
        const game = player.game;
        const moonData = game.moonData;
        const lowestRate = Math.min(moonData.colonyRate, moonData.logisticRate, moonData.miningRate);
        if (lowestRate > 0) {
            player.addProduction(Resources_1.Resources.MEGACREDITS, lowestRate, { log: true });
        }
        this.isDisabled = true;
        return undefined;
    }
}
exports.Neil = Neil;
//# sourceMappingURL=Neil.js.map